import { RoadMessagesDTO, RoadStatusesDTO } from "entities/shared/roadCard.types";
import { DateTimeModel, SearchCoordinateDTO, SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { ShipmentCardMetadataDTO } from "entities/shared/subscriptionModel";
import { ValueOf } from "shared/lib/typeCheck.lib";

export const TransportTypeDTO = {
  TRUCK: "TRUCK",
} as const;

export type FromDTO = {
  location?: string;
  estimated_departure?: DateTimeModel | null;
  actual_departure?: DateTimeModel | null;
};

export type ToDTO = {
  location?: string;
  estimated_arrival?: DateTimeModel | null;
  actual_arrival?: DateTimeModel | null;
};

export type FreightDTO = {
  quantity: number;
  weight: number;
  cargo_units: string[];
};

export type LocationDTO = {
  id: string | null;
  name: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  country_code: string | null;
  address: string | null;
  locode: string | null;
  lat: number | null;
  lng: number | null;
  timezone: string | null;
};

export type TransportDTO = {
  number: string;
  type: ValueOf<typeof TransportTypeDTO>;
};

export type LegDTO = {
  order_id: number | null;
  status: ValueOf<typeof RoadStatusesDTO>;
  from: FromDTO | null;
  to: ToDTO | null;
  freight: FreightDTO | null;
  transport: TransportDTO;
  path?: SearchCoordinateDTO[];
};

export type EventDTO = {
  order_id: number | null;
  event_code: string | null;
  description: string | null;
  extended_description: string | null;
  date_time: {
    estimated: DateTimeModel | null;
    actual: DateTimeModel | null;
  };
  location: LocationDTO | null;
  from: FromDTO | null;
  to: ToDTO | null;
  freight: FreightDTO | null;
  transport: TransportDTO;
};

export type RoadResponseDTO = {
  success: boolean;
  status_code: ValueOf<typeof RoadMessagesDTO>;
  metadata: {
    request_parameters: {
      number: SearchReferenceDTO;
      carrier_code?: string;
      type?: string;
    };
    type?: string;
    updated_at: DateTimeModel;
    cache_expires: DateTimeModel;
    from_cache: boolean;
    carrier: {
      name: string;
      url: string;
      carrier_code: string;
    };
  } & ShipmentCardMetadataDTO;
  data: {
    from: FromDTO;
    to: ToDTO;
    freight: FreightDTO;
    status: ValueOf<typeof RoadStatusesDTO>;
    locations: LocationDTO[];
    legs: LegDTO[];
    events: EventDTO[];
  };
};
